<form [formGroup]="form">
  <ion-grid class="ftp-scan-row">
    <ng-container formArrayName="ftpEvents">
      @for (item of getArray.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <ion-row>
            <!-- Secure FTPS-->
            <ion-col size="1">
              <div class="secure-container">
                <p class="text-label">
                  {{ CONSTANTS.SECURE_FTP }}
                </p>
                <app-form-checkbox
                  formControlName="isSecureftp"
                ></app-form-checkbox>
              </div>
            </ion-col>
            <!------------------>
            <!-- HostName -->
            <ion-col size="2">
              <app-form-input-field
                formControlName="hostName"
                [label]="CONSTANTS.HOST_NAME"
                [placeholder]="CONSTANTS.HOST_NAME_PLACEHOLDER"
                [autoCapitalize]="false"
              ></app-form-input-field>
            </ion-col>
            <!------------------>
            <!-- Directory -->
            <ion-col size="2">
              <app-form-input-field
                formControlName="directory"
                [label]="CONSTANTS.DIRECTORY"
                [placeholder]="CONSTANTS.DIRECTORY_PLACEHOLDER"
                [autoCapitalize]="false"
              ></app-form-input-field>
            </ion-col>
            <!------------------>
            <!-- User Name -->
            <ion-col size="2">
              <app-form-input-field
                formControlName="userName"
                [label]="CONSTANTS.USER_NAME"
                [placeholder]="CONSTANTS.USER_NAME_PLACEHOLDER"
                [autoCapitalize]="false"
              ></app-form-input-field>
            </ion-col>
            <!------------------>
            <!-- Password -->
            <ion-col size="2">
              <app-form-input-field
                formControlName="password"
                [label]="CONSTANTS.PASSWORD"
                [placeholder]="CONSTANTS.PASSWORD_PLACEHOLDER"
                [autoCapitalize]="false"
              ></app-form-input-field>
            </ion-col>
            <!------------------>
            <!-- Port Number -->
            <ion-col size="2">
              <app-form-input-field
                formControlName="sftpPortnum"
                [label]="CONSTANTS.PORT_NUMBER"
                [placeholder]="CONSTANTS.PORT_NUMBER_PLACEHOLDER"
                [autoCapitalize]="false"
              ></app-form-input-field>
            </ion-col>
            <!------------------>
            <!-- Actions -->
            <ion-col size="1" class="hv-center">
              @if (this.getArray.controls[i].valid) {
                <ion-button
                  class="delete-btn"
                  fill="clear"
                  (click)="deleteFtpScanRow(i)"
                >
                  <img [src]="'assets/Trash_Red.svg'" alt="" class="trash" />
                </ion-button>
              } @else {
                <ion-button class="delete-btn" fill="clear">
                  <img [src]="IMAGES.DELETE_INACTIVE" alt="" class="trash" />
                </ion-button>
              }
            </ion-col>
            <!------------------>
          </ion-row>
        </div>
      }
    </ng-container>
  </ion-grid>
  <ion-row class="add-ftp-row ion-justify-content-end">
    <ion-col size="1">
      <ion-button class="add-btn" (click)="addFtpScanRow()">
        <ion-icon class="icon" [src]="IMAGES.ADD_CIRCLE"></ion-icon>
        <span class="text">
          {{ CONSTANTS.ADD }}
        </span>
      </ion-button>
    </ion-col>
  </ion-row>
</form>
